"use strict";
/**
 * Combine all reducers in this file and export the combined reducers.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var connected_react_router_1 = require("connected-react-router");
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_1 = require("redux");
var redux_firestore_1 = require("redux-firestore");
var reducer_1 = __importDefault(require("containers/App/reducer"));
var history_1 = __importDefault(require("utils/history"));
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
exports.default = (function (injectedReducers) {
    if (injectedReducers === void 0) { injectedReducers = {}; }
    return (0, redux_1.combineReducers)(__assign({ router: (0, connected_react_router_1.connectRouter)(history_1.default), firebase: function (s, a) { return (0, react_redux_firebase_1.firebaseReducer)(s, a); }, firestore: function (s, a) { return (0, redux_firestore_1.firestoreReducer)(s, a); }, app: reducer_1.default }, injectedReducers));
});
